module.exports = __webpack_public_path__ + "static/images/calendar.8e6f2a9effdbf3407d82620735cbf38c.svg";